const Footer = () => {
    return (
        <footer>
            <p>Main data provided by <a href="https://restcountries.com/" title="Countries REST API">RestCountries.com</a></p>
            <p>Powered by <a href="https://www.weatherapi.com/" title="Free Weather API">WeatherAPI.com</a></p>
            <p>View source code on <a href='https://github.com/sukalov/FullStackOpen/tree/main/part2/countries'>Github</a></p>
            <p>Created as a test project for <a href="https://fullstackopen.com/" title="FullStackOpen free Web Development course">FullStackOpen</a></p>
        </footer>
    )
}

export default Footer